
import { ICoreFrameGridOptions} from "../Interfaces";
import { CoreFrameGrid } from "../index";
import { Utilities } from "../Utilities";


export abstract class HTMLTable {

    protected $wrapper: JQuery<HTMLElement> = undefined;
    $table: JQuery<HTMLElement> = undefined;
    $colgroup: JQuery<HTMLElement> = undefined;
    protected grid: CoreFrameGrid;
    protected options: ICoreFrameGridOptions;
    protected gridIdentifier: string;

    constructor(wrapperCSS: string, options: ICoreFrameGridOptions, grid: CoreFrameGrid) {
        this.gridIdentifier = Utilities.getRandomIdentifier();
        this.options = options;
        this.grid = grid;
        this.$wrapper = $('<div class="' + wrapperCSS + '">');
        this.$wrapper.attr('grid-identifier', this.gridIdentifier);
        this.$table = $('<table role="grid">');
        this.$colgroup = $('<colgroup>');

        this.$colgroup.appendTo(this.$table);
        this.$table.appendTo(this.$wrapper);

        this.$table[0].style.borderSpacing = "0";
        this.$table[0].style.tableLayout = "fixed";
        this.$table[0].style.width = "100%";
    }

    public getWrapper(){
        return this.$wrapper;
    }

    public getIdentifier(): string {
        return this.gridIdentifier;
    }

    protected clone<T extends Node>(node: T): T {
        return node.cloneNode(true) as T;
    }
}

